import "@/App.css";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner.jsx";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider, IS_PREVIEW } from "@/lib/i18n";
import CustomCursor from "@/components/CustomCursor";
import Loader from "@/components/Loader";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Investment from "@/pages/Investment";
import Partnerships from "@/pages/Partnerships";
import SaudiArabia from "@/pages/SaudiArabia";
import Portfolio from "@/pages/Portfolio";
import PortfolioDetail from "@/pages/PortfolioDetail";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Contact from "@/pages/Contact";
import Opportunity from "@/pages/Opportunity";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import AuthCallback from "@/pages/admin/AuthCallback";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

const Site = ({ children }) => <Layout>{children}</Layout>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Site><Home /></Site>} />
      <Route path="/about" element={<Site><About /></Site>} />
      <Route path="/investment" element={<Site><Investment /></Site>} />
      <Route path="/partnerships" element={<Site><Partnerships /></Site>} />
      <Route path="/saudi-arabia" element={<Site><SaudiArabia /></Site>} />
      <Route path="/portfolio" element={<Site><Portfolio /></Site>} />
      <Route path="/portfolio/:slug" element={<Site><PortfolioDetail /></Site>} />
      <Route path="/insights" element={<Site><Insights /></Site>} />
      <Route path="/insights/:slug" element={<Site><InsightDetail /></Site>} />
      <Route path="/contact" element={<Site><Contact /></Site>} />
      <Route path="/opportunity" element={<Site><Opportunity /></Site>} />
      <Route path="/privacy" element={<Site><Legal type="privacy" /></Site>} />
      <Route path="/terms" element={<Site><Legal type="terms" /></Site>} />
      <Route path="/cookies" element={<Site><Legal type="cookies" /></Site>} />

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />

      <Route path="*" element={<Site><NotFound /></Site>} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            {!IS_PREVIEW && <CustomCursor />}
            {!IS_PREVIEW && <Loader />}
            <Toaster theme="dark" position="bottom-right" />
            <AppRouter />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
